var map = {
	"./new_s_default.json": [
		33951,
		3951
	],
	"./new_s_default_eur.json": [
		2108,
		2108
	],
	"./new_s_default_gbp.json": [
		55611,
		5611
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 80053;
module.exports = webpackAsyncContext;